import { useEffect } from 'react';
import { useContent } from '@parcel2go/npm-p2g-app';
import useQuote from './use-quote';
import { ConfigurableParameters } from '~/lib/configurable-parameters';
import { QuoteAddress } from '~/lib/types/basket-types';
import { BasketSections } from '~/lib/types/enums';
import useBasketSection from './use-basket-section';

export const useOrderContent = () => {
  const { dispatch } = useContent();
  const { quote } = useQuote();
  const orgin = useBasketSection<QuoteAddress>({ name: BasketSections.ORIGIN });
  const destination = useBasketSection<QuoteAddress>({ name: BasketSections.DESTINATION });

  useEffect(() => {
    if (quote?.service?.courierSlug && quote?.service?.slug && destination?.data?.country && orgin?.data?.country) {
      dispatch(
        new ConfigurableParameters({
          courier: quote.service.courierSlug,
          service: quote.service.slug,
          origin: orgin.data.country,
          destination: destination.data.country
        })
      );
    }
  }, [dispatch, quote?.service?.courierSlug, quote?.service?.slug, destination?.data?.country, orgin?.data?.country]);
};
